import { render } from "./ExpensesBodySk.vue?vue&type=template&id=1dc62591"
import script from "./ExpensesBodySk.vue?vue&type=script&lang=js"
export * from "./ExpensesBodySk.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__